import { useForm, type FieldValues, type Path, type DefaultValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { ZodType } from 'zod';
import { opportunityErrors } from '@/pages/Opportunities/api';

export const useActionForm = <T extends FieldValues>(schema: ZodType<T>, defaults: DefaultValues<T>, action: (values: T) => Promise<void>) => {
    const { t } = useTranslation('global');
    const form = useForm<T>({ defaultValues: defaults });
    const submit = form.handleSubmit(async values => {
        form.clearErrors();
        const parsed = schema.safeParse(values);
        if(!parsed.success){
            for(const issue of parsed.error.issues){
                form.setError(issue.path.join('.') as Path<T>, { message: t(issue.message.startsWith('opportunities.') ? issue.message : 'opportunities.required') });
            }
            form.setError('root', { message: t('opportunities.check_fields') });
            return;
        }
        try{
            await action(parsed.data);
        }
        catch(error){
            form.setError('root', { message: Object.values(opportunityErrors(error)).join(' ') });
        }
    });
    return { form, submit, busy: form.formState.isSubmitting, error: form.formState.errors.root?.message };
};
